// @flow
type T_YES_NO_BLOCK_MODULE_NAME = 'YES_NO_BLOCK_MODULE';
const YES_NO_BLOCK_MODULE_NAME: T_YES_NO_BLOCK_MODULE_NAME = 'YES_NO_BLOCK_MODULE';

export {YES_NO_BLOCK_MODULE_NAME};
export type {T_YES_NO_BLOCK_MODULE_NAME};
